import { motion } from "framer-motion";
import { ImageIcon } from "lucide-react";
import { Reveal, MaskText, Eyebrow } from "@/components/motion";
import { MEDIA } from "@/lib/content";

const RESULTS = [
  ["Spider Lift", "Protocollo viso liftante non invasivo."],
  ["Doll Skin", "Pelle uniforme e luminosa."],
  ["Double Lift", "Massaggio liftante viso."],
  ["Miracle Mask 2.0", "Maschera professionale rigenerante."],
  ["BodyOne 369", "Protocollo corpo rimodellante."],
  ["Nuovo protocollo", "Spazio per la novità da svelare."],
];

const Half = ({ src, label, tone }) => (
  <div className={`relative h-full overflow-hidden ${tone}`}>
    {src ? (
      <img src={src} alt={label} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
    ) : (
      <div className="flex h-full w-full items-center justify-center"><ImageIcon className="h-6 w-6 text-gold/30" strokeWidth={1.2} /></div>
    )}
    <span className="absolute bottom-3 left-3 rounded-full bg-ink/80 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-gold-light backdrop-blur">{label}</span>
  </div>
);

const ResultCard = ({ name, desc, i }) => {
  const m = MEDIA.results[name] || {};
  return (
    <Reveal delay={(i % 3) * 0.08} className="h-full">
      <article className="card-lux group h-full overflow-hidden" data-testid={`result-card-${i}`}>
        <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
        <motion.div
          variants={{ hidden: { clipPath: "inset(0 0 100% 0)" }, show: { clipPath: "inset(0 0 0% 0)" } }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          className="grid aspect-[4/3] grid-cols-2 gap-px bg-line"
        >
          <Half src={m.before} label="Prima" tone="bg-[#100c07]" />
          <Half src={m.after} label="Dopo" tone="bg-[#18120a]" />
        </motion.div>
        </motion.div>
        <div className="p-6">
          <h3 className="text-2xl text-cream">{name}</h3>
          <p className="mt-1 text-sm text-sand">{desc}</p>
        </div>
      </article>
    </Reveal>
  );
};

export const Results = () => (
  <section className="section border-t border-line" data-testid="results-section">
    <div className="wrap">
      <Eyebrow>I risultati</Eyebrow>
      <MaskText className="h2 mt-6" lines={["Parlano le pelli", <em className="gold-text">delle clienti.</em>]} />
      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {RESULTS.map(([n, d], i) => <ResultCard key={n} name={n} desc={d} i={i} />)}
      </div>
    </div>
  </section>
);

const POINTS = [
  "Proponi percorsi, non singoli trattamenti.",
  "Lo scontrino medio sale, perché sale il valore percepito.",
  "La cliente torna e porta le amiche, perché vede i risultati.",
  "Esci dalla guerra dei prezzi con un metodo che nessun altro ha in zona.",
];

export const Expert = () => (
  <section className="section border-t border-line bg-ink2" data-testid="expert-section">
    <div className="wrap grid gap-14 lg:grid-cols-[1fr_1fr]">
      <div>
        <Eyebrow>Professionista della pelle</Eyebrow>
        <MaskText className="h2 mt-6" lines={["Quando la cliente ti vede", "come un'esperta, smette", <em className="gold-text">di chiederti lo sconto.</em>]} />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {POINTS.map((p, i) => (
          <Reveal key={p} delay={i * 0.08} className="h-full">
            <div className="card-lux h-full p-7" data-testid={`expert-point-${i}`}>
              <i className="font-serif text-5xl not-italic text-gold">{i + 1}</i>
              <p className="mt-6 text-[15px] leading-relaxed text-cream">{p}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
